var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"table-filters"},[_c('form',{ref:"filters"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"mt-2 text-right"},[_c('b-button',{attrs:{"variant":"outline-info"},on:{"click":function($event){return _vm.$emit('clear-filters')}}},[_vm._v("Clear")])],1)],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }